import React, { useState } from 'react';
import axios from 'axios';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
} from 'reactstrap';

const subscribeStyles = {
  subscribeNewsletter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    paddingTop: '0px',
  },
  subscribeInput: {
    padding: '10px',
    border: '1px solid #02223A',
    borderRadius: '5px 0 0 5px',
    width: '15em',
    height: '4em',
  },
  subscribeButton: {
    backgroundColor: '#02223A',
    borderColor: '#02223A',
    borderRadius: '0 5px 5px 0',
    height: '4em',
    transition: 'background-color 0.3s ease',
  },
  arrowIcon: {
    fontSize: '10px',
  },
};

const SubscribeNewsletter = ({ serverEndpoint }) => {
  const [email, setEmail] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [submitEnabled, setSubmitEnabled] = React.useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
  };

  const isValidEmail = (inputEmail) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(inputEmail);
  };

  const subscribe = async (e) => {
    e.preventDefault();

    try {
      if (!isValidEmail(email)) {
        window.alert('Please enter a valid email address.');
        return;
      }

      setSubmitEnabled(false);

      console.log(serverEndpoint); // debugging
      const response = await axios.post(
        serverEndpoint,
        {
          email: email,
        }
      );

      console.log(response.status)
      if (response.status === 200) {
        setEmail('');
        window.alert('Successfully subscribed! Check your email for updates.');
      } else {
        window.alert('Failed to subscribe. Please try again later.');
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        window.alert('You are already subscribed.');
        setEmail('');
      } else {
        console.error('Error subscribing:', error.message);
        window.alert('Error subscribing. Please try again later.');
      }
    }

    setSubmitEnabled(true);
  };

  return (
    <div style={subscribeStyles.subscribeNewsletter}>
      <form onSubmit={subscribe}>
        <InputGroup>
          <Input
            type="email"
            placeholder="Subscribe to Newsletter"
            style={subscribeStyles.subscribeInput}
            value={email}
            onChange={handleEmailChange}
            required
          />
          <InputGroupAddon addonType="append">
            <Button
              style={{
                ...subscribeStyles.subscribeButton,
                backgroundColor: isHovered ? '#356487' : '#02223A',
                borderColor: isHovered ? '#356487' : '#02223A',
              }}
              size="lg"
              type="submit"
              aria-label='Subscribe for MagLev Updates'
              onMouseEnter={() => setIsHovered(true && submitEnabled)}
              onMouseLeave={() => setIsHovered(false && submitEnabled)}
              disabled={!submitEnabled}
            >
              <i className="fa fa-arrow-right"></i>
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </form>
    </div>
  );
}

export default SubscribeNewsletter;
